<template>
  <div
    v-if="selectedDay ? selectedDay?.panelSessions.length > 0 : false"
    class="pt-8 lg:hidden user-schedule__selected-day"
  >
    <ol class="user-schedule__selected-day__list divide-y overflow-hidden">
      <UserScheduleMobileSelectedDayPanelSession
        v-for="panelSession in selectedDay?.panelSessions"
        :key="panelSession.id"
        :panel-session="panelSession"
      />
    </ol>
  </div>
</template>
<script setup lang="ts">
import type { UserScheduleDay } from '@/types/UserScheduleDay'
import UserScheduleMobileSelectedDayPanelSession from '@/components/UserSchedule/UserScheduleMobileSelectedDayPanelSession.vue'

defineProps<{
  selectedDay?: UserScheduleDay
}>()
</script>
<style scoped lang="scss">
.user-schedule__selected-day__list {
  border: 1px solid var(--ych-grey-400);
  border-color: var(--ych-grey-400);
  border-radius: var(--y-radius-md);
}
</style>
